import styled from '@emotion/styled';
import { FlexBox } from '@shared/helpers';

export const AZStepsFooter = styled(FlexBox)`
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid ${({ theme }) => theme?.colors?.border};
`;
